<form autocomplete="off" #form="ngForm">
    <div class="app-grid margin-bottom-4">
        <div class="columns-12">
            <h2>{{ 'forms.change-requests.requestName' | translate }}</h2>
            <p>
                {{
                    ChangeRequestTemplateDisplayOptions[changeRequestTemplate.name] || changeRequestTemplate.name
                        | translate
                }}
            </p>
        </div>
    </div>

    <div class="app-grid margin-bottom-4">
        <h2 id="request-description-header">{{ 'forms.change-requests.requestDescription' | translate }}</h2>
        <mat-form-field class="no-labels no-helpers">
            <textarea
                matInput
                rows="4"
                maxlength="1000"
                class="padding-top-0"
                [(ngModel)]="changeRequestTemplate.description"
                name="description"
                aria-labelledby="request-description-header"
            ></textarea>
        </mat-form-field>
    </div>

    <div class="app-grid">
        <div class="columns-12">
            <h2>{{ 'forms.change-requests.requestField' | translate }}</h2>
            <p>{{ 'forms.change-requests.fieldsAvailablityInstruction' | translate }}</p>
            <ul>
                <li *ngFor="let field of changeRequestTemplate.changeRequestTemplateFields">
                    {{ field.name | appTranslateOptions: changeRequestTemplateFields }}
                </li>
            </ul>
        </div>
    </div>
</form>
